import { useSelector } from "react-redux";
import { handleValidateCodevalue } from "../Utility/constant";
import CommonEmail from "./CommonEmail";
import { StyledLeadContainer, StyledSubHeader } from "./Styled";
import TextFiledWithLabel from "./TextFieldWithLabel";
import NumericTextField from "./NumericTextfield";

const CommonPoc = ({required = false ,isDetailPage,isViewMode,requiredValue, handleOnChange , state} ) => {

  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)

  return (
    <>
    <StyledSubHeader>
    {handleValidateCodevalue(internationalise,'COMMON_POC_DETAILS')} 
    </StyledSubHeader>
    <StyledLeadContainer>
    <TextFiledWithLabel
    required={required}
    name= "pocFirstName"
    isViewMode = {isViewMode}
    value= {state?.pocFirstName}
    error={state?.pocFirstName ? false : requiredValue?.pocFirstName}
    label={handleValidateCodevalue(internationalise,'COMMON_POC_FIRSTNAME')}
    handleOnChange={handleOnChange}
    helperText= ""
    />
    
    <TextFiledWithLabel
    required={required}
    name= "pocLastName"
    isViewMode = {isViewMode}
    value= {state?.pocLastName}
    error={state?.pocLastName ? false : requiredValue?.pocLastName}
    label={handleValidateCodevalue(internationalise,'COMMON_POC_LASTNAME')}
    handleOnChange={handleOnChange}
    helperText= ""
    />
    <NumericTextField
    required={required}
    isDetailPage = {isDetailPage}
    isViewMode={isViewMode}
    name = 'pocPhone'
    isRequired={requiredValue?.pocPhone}
    value={state?.pocPhone}
    handleOnChange={handleOnChange}
    />
    <CommonEmail
    required={required}
    isDetailPage = {isDetailPage}
    isViewMode={isViewMode}
    requiredValue = {requiredValue?.pocEmail}
    name = 'pocEmail'
    value = {state?.pocEmail}
    isRequired = {requiredValue?.pocEmail}
    handleOnChange={handleOnChange}
    />
</StyledLeadContainer>
</>)
}

export default CommonPoc

